import {
  GET_KPIS_LIST,
  GET_QUESTIONS_BY_KPI,
  GET_ALL_KPI_QUESTIONS_LIST,
  GET_SURVEY_LIST,
  SURVEY_PROGRESS_STEPS,
  ADD_SURVEY_ELEMENT,
  GET_ALL_MODEL_BY_ID,
  GET_RETAILER_BY_IDRETAILER_IDCLIENT,
  GET_ALL_LOCATION,
  GET_ALL_SECTOR,
  GET_SURVEY_SECTORS_LIST,
  GET_SURVEY_ENSEIGNES_LIST,
  GET_SURVEY_MODELES_LIST,
  UPDATE_SURVEY,
  ADD_ELEMENT_MLAB,
  GET_ALL_USER_MLAB,
  GET_CURRENT_USER_MLAB,
  SURVEY_UPDATE_LOCATION_TYPES,
  SURVEY_SET_PROGRESS,
  SURVEY_SET_CURRENT_MODEL,
  SET_ARCHIVE_SURVEY,
  SURVEY_SET_FILTERS,
  SURVEY_SET_CURRENT_FILTERS,
  SURVEY_SET_PAGINATION,
  SET_SURVEY_LIST,
  SET_KEY_SURVEY_FILTER_SELECTED,
  SET_SURVEY_SORT,
  SURVEY_SET_CURRENT_TITLE,
  SURVEY_CREATION_SET_ACTIONSLIST,
  SURVEY_PROGRESS_ADD_END_VISIT_STATEMENT,
  SURVEY_CREATION_SET_ACTIONTYPES,
  SURVEY_SET_LIST_LOADING
} from "./../../types";
import { sector } from "./fakeDate";

import { createReducer, createApiHandlers } from "./../functions";

import { generateSector, generateModele } from "./functions";

import _ from "lodash";
import {
  SURVEY_CREATION_SET_KPISLIST,
  SURVEY_CREATION_SET_MODELSLIST,
  SURVEY_CREATION_SET_SECTORSLIST,
  SURVEY_PROGRESS_REMOVE_END_VISIT_STATEMENT
} from "../../types";

const initialState = {
  surveyList: [],
  surveyListLoading: false,
  keyFilterSelected: "",
  filters: [],
  currentFilters: {},
  surveySort: 1,
  keySortSelected: "status.id",
  hasNext: false,
  page: 0,
  pages: 0,
  pageSize: 10,
  surveyProgress: {},
  surveySectorsList: [],
  allKpiQuestions: [],
  questionsByKpi: [],
  modeleList: [],
  currentSurvey: {},
  locatonList: [],
  surveyModelesList: [],
  surveyEnseigneList: [],
  assortmentClient: [],
  sectorList: [],
  secteurList: [],
  userElement: [],
  currentUser: {},
  actionsList: [],
  actionTypes: []
};

const setSurvey = {
  [SET_SURVEY_LIST]: (state, action) => {
    const surveyList = action.payload.docs;
    const page = action.payload.hasOwnProperty("page") ? action.payload.page : state.page;
    const pages = action.payload.hasOwnProperty("pages") ? action.payload.pages : state.pages;
    let hasNext = true;
    if (page === 0 || page === pages) hasNext = false;

    return {
      ...state,
      page,
      pages,
      hasNext,
      surveyList,
      secteurList: generateSector(surveyList),
      modeleList: generateModele(surveyList, sector)
    };
  },
  [SURVEY_SET_LIST_LOADING]: (state, action) => {
    return {
      ...state,
      surveyListLoading: action.loading
    };
  }
};

const setFilters = {
  [SURVEY_SET_FILTERS]: (state, action) => {
    return { ...state, filters: action.filters };
  }
};

const setKeyFilterSelected = {
  [SET_KEY_SURVEY_FILTER_SELECTED]: (state, action) => {
    return { ...state, keyFilterSelected: action.key };
  }
};

const setPagination = {
  [SURVEY_SET_PAGINATION]: (state, action) => {
    return Object.assign({}, state, { page: action.page, pages: action.pages });
  }
};

const setSurveySort = {
  [SET_SURVEY_SORT]: (state, action) => {
    return {
      ...state,
      surveySort: -state.surveySort,
      keySortSelected: action.key,
      page: 1
    };
  }
};

const setArchiveSurvey = {
  [SET_ARCHIVE_SURVEY]: (state, action) => {
    const surveyArchived = action.payload;
    const newSurvey = state.surveyList.map(survey => {
      return survey.surveyId === surveyArchived.surveyId ? surveyArchived : survey;
    });

    return {
      ...state,
      surveyList: newSurvey
    };
  }
};

const setCurrentFilters = {
  [SURVEY_SET_CURRENT_FILTERS]: (state, action) => {
    return Object.assign({}, state, { currentFilters: action.currentFilters });
  }
};
//End of reducer that I created (Ornella)

const getKpisHandlers = createApiHandlers(GET_KPIS_LIST, (state, action) => {
  return {
    ...state,
    kpisList: action.payload.data.kpis,
    actionsList: action.payload.data.actions
  };
});

const getquestionsByKpiHandlers = createApiHandlers(GET_QUESTIONS_BY_KPI, (state, action) => {
  return { ...state, questionsByKpi: action.payload.data };
});

const getAllKpiquestionsHandlers = createApiHandlers(GET_ALL_KPI_QUESTIONS_LIST, (state, action) => {
  return { ...state, allKpiQuestions: action.payload.data };
});

const getModelsSurveyHandlers = createApiHandlers(GET_ALL_MODEL_BY_ID, (state, action) => {
  return { ...state, modeleList: action.payload.data };
});

const updateProgressSurveyHandlers = createApiHandlers(SURVEY_PROGRESS_STEPS, (state, action) => {
  return { ...state, surveyProgress: action.payload.data };
});

const simulationSurveyHandlers = createApiHandlers(ADD_SURVEY_ELEMENT, (state, action) => {
  if (action.payload.data !== null) {
    return { ...state, currentSurvey: action.payload.data };
  }
});

const locationsSurveyHandlers = createApiHandlers(GET_ALL_LOCATION, (state, action) => {
  return { ...state, locatonList: action.payload.data };
});

const assortmentClientSurveyHandlers = createApiHandlers(GET_RETAILER_BY_IDRETAILER_IDCLIENT, (state, action) => {
  return { ...state, assortmentClient: action.payload.data };
});

const sectorSurveyHandlers = createApiHandlers(GET_ALL_SECTOR, (state, action) => {
  return { ...state, sectorList: action.payload.data };
});

const surveySectorListHandlers = createApiHandlers(GET_SURVEY_SECTORS_LIST, (state, action) => {
  return { ...state, surveySectorsList: action.payload.data };
});

const surveyEnseignesListHandlers = createApiHandlers(GET_SURVEY_ENSEIGNES_LIST, (state, action) => {
  return { ...state, surveyEnseigneList: action.payload.data };
});

const surveyModeleListHandlers = createApiHandlers(GET_SURVEY_MODELES_LIST, (state, action) => {
  return { ...state, surveyModelesList: action.payload.data };
});
const userElementHandlers = createApiHandlers(ADD_ELEMENT_MLAB, (state, action) => {
  return { ...state, userElement: action.payload.data };
});

const userAllElementHandlers = createApiHandlers(GET_ALL_USER_MLAB, (state, action) => {
  return { ...state, userElement: action.payload.data };
});

const surveyUpdateLocationTypesHandlers = {
  [SURVEY_UPDATE_LOCATION_TYPES]: (state, action) => {
    return {
      ...state,
      surveyProgress: {
        ...state.surveyProgress,
        locationTypes: [...action.locationTypes]
      }
    };
  }
};

const surveySetCurrentTitle = {
  [SURVEY_SET_CURRENT_TITLE]: (state, action) => {
    // console.log('action::', action.currentTitle)
    // console.log('state surveyProgress:', state.surveyProgress)
    return {
      ...state,
      surveyProgress: {
        ...state.surveyProgress,
        surveyTitle: action.currentTitle
      }
    };
  }
};

const surveySetCurrentModel = {
  [SURVEY_SET_CURRENT_MODEL]: (state, action) => {
    return {
      ...state,
      surveyProgress: {
        ...action.surveyProgress,
        currentModel: action.currentModel
      }
    };
  }
};

const surveySetProgress = {
  [SURVEY_SET_PROGRESS]: (state, action) => {
    return { ...state, surveyProgress: { ...action.surveyProgress } };
  }
};

/**
 * update surveyProgress.end_visit_statement field
 */
const surveySetProgressEndVisitStatement = {
  [SURVEY_PROGRESS_ADD_END_VISIT_STATEMENT]: (state, action) => {
    return {
      ...state,
      surveyProgress: {
        ...state.surveyProgress,
        end_visit_statement: action.statement
      }
    };
  }
};

/**
 * remove surveyProgress.end_visit_statement field
 */
const surveyRemoveProgressEndVisitStatement = {
  [SURVEY_PROGRESS_REMOVE_END_VISIT_STATEMENT]: (state, action) => {
    const surveyProgress = state.surveyProgress;
    surveyProgress.end_visit_statement = null;

    delete surveyProgress.end_visit_statement;
    return {
      ...state,
      surveyProgress: {
        ...surveyProgress
      }
    };
  }
};

const userCurrentHandlers = createApiHandlers(GET_CURRENT_USER_MLAB, (state, action) => {
  return { ...state, currentUser: action.payload.data };
});

//TODO refactor
const newApiHandler = {
  [SURVEY_CREATION_SET_KPISLIST]: (state, action) => {
    return {
      ...state,
      kpisList: action.kpis
    };
  },
  [SURVEY_CREATION_SET_ACTIONSLIST]: (state, action = {}) => {
    const statements = action.actions || [];
    return {
      ...state,
      actionsList: statements
    };
  },
  [SURVEY_CREATION_SET_ACTIONTYPES]: (state, action = {}) => {
    const statements = action.statements || [];
    const actionTypes = [];
    for (const statement of statements) {
      actionTypes.push({
        id: statement.id,
        label: statement.label,
        actions: statement.actions
      });
    }

    return {
      ...state,
      actionTypes: actionTypes
    };
  },
  [SURVEY_CREATION_SET_SECTORSLIST]: (state, action) => {
    return {
      ...state,
      sectorList: action.sectors
    };
  },
  [SURVEY_CREATION_SET_MODELSLIST]: (state, action) => {
    return {
      ...state,
      assortmentClient: action.models
    };
  }
};
const surveyReducer = createReducer(initialState, {
  ...setSurvey,
  ...setFilters,
  ...setKeyFilterSelected,
  ...setPagination,
  ...setSurveySort,
  ...setArchiveSurvey,
  ...setCurrentFilters,
  //
  ...surveySetCurrentTitle,
  ...surveySetCurrentModel,
  ...getKpisHandlers,
  ...getquestionsByKpiHandlers,
  ...getAllKpiquestionsHandlers,
  // ...getAllSurveyHandlers,
  ...updateProgressSurveyHandlers,
  ...simulationSurveyHandlers,
  ...getModelsSurveyHandlers,
  ...assortmentClientSurveyHandlers,
  ...locationsSurveyHandlers,
  ...sectorSurveyHandlers,
  ...surveySectorListHandlers,
  ...surveyEnseignesListHandlers,
  ...surveyModeleListHandlers,
  // ...updateSurveyHandlers,
  ...userElementHandlers,
  ...userAllElementHandlers,
  ...surveyUpdateLocationTypesHandlers,
  ...surveySetProgress,
  ...userCurrentHandlers,
  // ...archiveSurveyHandlers,
  ...newApiHandler,
  ...surveySetProgressEndVisitStatement,
  ...surveyRemoveProgressEndVisitStatement
});
export default surveyReducer;



// WEBPACK FOOTER //
// src/redux/reducers/surveyReducer/surveyReducer.js